module.exports = __webpack_public_path__ + "media/images/sp/top/icon-location-4698b890158ad1214c980f21574a9909.png";